export default __webpack_public_path__ + "static/media/refill_4.604d865c.wav";